import { TRACKS_SAGA_GET_TRACKS } from '../actionTypes'

export default () => ({ type: TRACKS_SAGA_GET_TRACKS })
